<template>
    <zen-one
        :showuserinfo="false"
        :crumbs="crumbs"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
    >
        <z-page title="Butiran Laporan Deposit Semasa">
            <w-card bg-color="" class="">
                <w-flex justify-center align-center>
                    <div class="xs4">
                        <h5 class="fw-semibold m0">No. Deposit :</h5>
                        <div class="fw-normal my1 fs-1">
                            {{ form.no_cagaran }}
                        </div>
                    </div>

                    <div class="xs4">
                        <h5 class="fw-semibold m0">No. Fail :</h5>
                        <div class="fw-normal my1 fs-1">{{ form.no_fail }}</div>
                    </div>

                    <div class="xs4">
                      <h5 class="fw-semibold m0">Amaun Deposit (RM) :</h5>
                        <div class="fw-normal my1 fs-1">
                            {{ $zutil.currency(form.amaun_deposit) }}
                        </div>
                    </div>
                </w-flex>

                <w-flex justify-center align-center>
                  <div class="xs4">
                        <h5 class="fw-semibold m0"></h5>
                        <h5 class="fw-semibold m0">Tarikh Deposit :</h5>
                        <div class="fw-normal my1 fs-1">
                            {{ $zutil.dateformat(form.created_at) }}
                        </div>
                    </div>
                    

                    <div class="xs4">
                       <h5 class="fw-semibold m0">Kod Akaun :</h5>
                        <div class="fw-normal my1 fs-1">
                            {{ form.akaun_kod }} | {{ form.akaun_keterangan }}
                        </div>
                    </div>

                    <div class="xs4">
                        <h5 class="fw-semibold m0">
                            Amaun Telah Bil (RM) :
                        </h5>
                        <div class="fw-normal my1 fs-1">
                            {{ $zutil.currency(form.amaun_telah_bil) }}
                        </div>
                    </div>
                </w-flex>

                <w-flex justify-center align-center>
                    <div class="xs4">
                        <h5 class="fw-semibold m0">Status :</h5>
                        <div class="fw-normal my1 fs-1">
                            {{ form.status_keterangan }}
                        </div>
                    </div>

                    <div class="xs4">
                      <h5 class="fw-semibold m0">Keterangan :</h5>
                        <div class="fw-normal my1 fs-1">
                            {{ form.keterangan }}
                        </div>
                    </div>

                    <div class="xs4">
                        <h5 class="fw-semibold m0">
                            Amaun Belum Bil (RM) :
                        </h5>
                        <div class="fw-normal my1 fs-1">
                            {{ $zutil.currency(form.amaun_belum_bil) }}
                        </div>
                    </div>
                </w-flex>
            </w-card>
                   
            <w-flex justify-center align-center>
                <div class="w-card__content content-hardcode">
                    <table class="table-dashboard" width="100%">
                        <thead>
                            <tr>
                                <td>No</td>
                                <td>Tarikh</td>
                                <td>Jenis Transaksi</td>
                                <td>No Rujukan</td>
                                <td>No Resit</td>
                                <td>Keterangan</td>
                                <td>Amaun (RM)</td>
                                <td>Baki Deposit (RM)</td>
                                <td>Dokumen</td>
                                <td>Status</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>
                                    {{
                                        $zutil.dateformat(
                                            form.created_at
                                        )
                                    }}
                                </td>
                                <td>DAFTAR</td>
                                <td>{{ form.no_cagaran }}</td>
                                <td></td>
                                <td>{{ form.keterangan }}</td>
                                <td align="right">
                                    {{
                                        $zutil.currency(
                                            form.amaun_deposit
                                        )
                                    }}
                                </td>
                                <td></td>
                                <td>
                                    <template
                                        v-if="form.lampiran_nama"
                                    >
                                        <a
                                            :href="
                                                form.lampiran_url
                                            "
                                            >{{
                                                form.lampiran_nama
                                            }}</a
                                        >
                                    </template>
                                </td>
                                <td>SELESAI</td>
                            </tr>
                            <tr v-for="( dt, index) in form.deposit_trans">
                                <td>{{ index + 2 }}</td>
                                <td>
                                    {{
                                        $zutil.dateformat(
                                            dt.created_at
                                        )
                                    }}
                                </td>
                                <td>
                                    {{
                                        dt.deposit_trans_keterangan
                                    }}
                                </td>
                                <td>{{ dt.no_rujukan }}</td>
                                <td>{{ dt.no_resit }}</td>
                                <td>{{ dt.keterangan }}</td>
                                <td align="right">
                                    {{ $zutil.currency(dt.amaun) }}
                                </td>
                                <td align="right">
                                    {{ $zutil.currency(dt.baki) }}
                                </td>
                                <td>
                                    <template
                                        v-if="dt.lampiran_nama"
                                    >
                                        <a
                                            :href="dt.lampiran_url"
                                            >{{
                                                dt.lampiran_nama
                                            }}</a
                                        >
                                    </template>
                                </td>
                                <td>{{ dt.status_trans }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </w-flex>
            <w-flex class="mt3" wrap align-center justify-end>
                <w-button
                    class="my1"
                    bg-color="warning"
                    dark
                    @click="back()"
                    >Kembali</w-button
                >
            </w-flex>
                   
        </z-page>
    </zen-one>
</template>

<script>
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {},
    props: {
        id: [Array, Object, String],
    },
    data() {
        return {
            isHidden: false,
            resourceurl: this.service_deposit + "deposit/show_laporan",
            reload: true,
            lkp_deposit_trans: [],
            deposit_trans: [],
            deposit: [],
            butiran: [{ akaun_id: null, amaun_debit: 0.0 }],
            butiran4: [{ akaun_id: 470, amaun_debit: 0.0 }],
            files: [],
            tabs: [
                { title: "Profil", content: "" },
                { title: "Transaksi", content: "" },
                { title: "Lain-Lain", content: "" },
                { title: "Tindakan", content: "" },
                { title: "Jejak Audit", content: "" },
            ],
            crumbs: [
                { label: "iHasil", route: "/" },
                { label: "Deposit", route: "/deposit/laporan/tahun_semasa" },
                { label: "Show", route: "/deposit/laporan/tahun_semasa/butiran/" + this.id },
            ],
            validators: {
                required: (value) => !!value || "Medan Ini engga Wajib Isi",
                consent: (value) => !!value || "You must agree",
                email: (value) =>
                    !!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/i) ||
                    "Sila Semak Format Email",
                numeric: (value) => !isNaN(value) || "Medan Ini Wajib Numeric",
            },
        };
    },
    methods: {
        clear () {
        this.getData()
          this.files = false
          this.$nextTick(() => {
            this.files = true
          })
        },
        change() {
          console.log('filechange');
        },
        back() {
            window.history.back();
        },

        depostTrans() {
            this.$zcomm
                .get(this.service_deposit + "lookup/deposit_trans")
                .then((res) => {
                    this.lkp_deposit_trans = res;
                })
                .catch((err) => {})
                .finally(() => {});
        },
        jenisTransaksi(form){
          this.isHidden = true
          if(form.lkp_deposit_trans_id == 4){
            
            this.butiran4[0].amaun_debit = form.amaun_baki
          }
          this.totalAmaunPewartaan();
        },

        baki(form) {
          if(form.lkp_deposit_trans_id != 1){
            var baki =
                form.amaun_inbois -
                form.amaun_bayaran -
                form.amaun_pelarasan -
                form.amaun_pewartaan;
              }else{
            var baki =
                form.amaun_belum_inbois
                
              }
                form.amaun_baki = baki - form.amaun;
        },

        totalAmaun() {
            this.form.amaun = 0;
            for (var i in this.butiran) {
                this.butiran[i].amaun_debit;
                this.form.amaun =
                    this.form.amaun + parseFloat(this.butiran[i].amaun_debit);
            }
            this.baki(this.form);
        },
        totalAmaunPewartaan() {
            this.form.amaun = 0;
            for (var i in this.butiran) {
                this.butiran4[i].amaun_debit;
                this.form.amaun =
                    this.form.amaun + parseFloat(this.butiran4[i].amaun_debit);
            }
            this.baki(this.form);
        },

        send() {
          if(this.form.valid == true){
            this.form.butiran = this.butiran;
            this.form.butiran4 = this.butiran4;
            this.$zcomm
                .update(
                    this.resourceurl + "/" + this.form.id,
                    this.form.id,
                    this.form
                )
                .then((res) => {
                    if (typeof this.onAfterEdit === "function") {
                        this.onAfterEdit();
                    }

                    this.$inertia.visit(this.$route("deposit.index"));
                    this.upload(res.id);
                })
                .catch((err) => {})
                .finally(() => {});
              }
        },

        upload(id) {
            let formData = new FormData();
            formData.append("file", this.files[0].file);
            formData.append("model", "App\\Models\\DepositTrans");
            formData.append("model_id", id);
            this.$zcomm
                .post(this.resourceurl + "/upload", formData)
                .then((res) => {
                    if (typeof this.onAfterAdd === "function") {
                        this.onAfterAdd();
                    }
                    this.$zutil.notify("Rekod telah berjaya dihantar");
                    this.$inertia.visit(this.$route("deposit.index"));
                })
                .catch((err) => {})
                .finally(() => {});
        },

        addItem() {
            this.butiran.push({ akaun_id: null, amaun_debit: 0.0 });
        },
        removeItem(index) {
            this.butiran.splice(index, 1);
        },

        addItem4() {
            this.butiran4.push({ akaun_id: 470, amaun_debit: 0.0 });
        },
        removeItem4(index) {
            this.butiran.splice(index, 1);
        },

        cetak(id) {
            //window.open(this.service_bil_pelbagai+'inbois/cetak'+id;
           window.open(this.service_deposit + "deposit/cetak/" + id,'_blank');
            },
        },
        watch: {},
    mounted() {
        this.depostTrans();
        this.butiran4 = [{akaun_id : 470, amaun_debit : 0.00} ]
    },
};
</script>
